<!--
  general-chatbot.component.html
  --------------------------------
  Standalone general guardrail chatbot page.
  Matches the CDAS Guardrails Assistant design shown in the screenshot.
-->

<div class="chatbot-page">

  <!-- ── Header ───────────────────────────────────────────────────────── -->
  <div class="chatbot-page__header">
    <h2 class="chatbot-page__title">CDAS General Guardrails Assistant</h2>
    <p class="chatbot-page__subtitle">
      Ask questions about IT, OT, PCN guardrails - I'll give you direct, complete answers from our database
    </p>
  </div>

  <!-- ── Message Thread ──────────────────────────────────────────────── -->
  <div class="chatbot-page__thread">
    <div
      *ngFor="let msg of messages()"
      class="chatbot-page__bubble"
      [class.chatbot-page__bubble--user]="msg.role === 'user'"
      [class.chatbot-page__bubble--assistant]="msg.role === 'assistant'">

      <!-- Assistant bubble: render HTML (markdown) -->
      <ng-container *ngIf="msg.role === 'assistant'">
        <span
          *ngIf="!msg.loading || msg.text"
          [innerHTML]="msg.html || msg.text">
        </span>
        <!-- Typing indicator shown when streaming and text is empty -->
        <span *ngIf="msg.loading && !msg.text" class="chatbot-page__typing">
          <span></span><span></span><span></span>
        </span>
        <!-- Cursor shown while streaming -->
        <span *ngIf="msg.loading && msg.text" class="chatbot-page__cursor">▌</span>
      </ng-container>

      <!-- User bubble: plain text -->
      <ng-container *ngIf="msg.role === 'user'">
        {{ msg.text }}
      </ng-container>

    </div>

    <!-- Scroll anchor -->
    <div #scrollAnchor></div>
  </div>

  <!-- ── Input Bar ────────────────────────────────────────────────────── -->
  <div class="chatbot-page__input-bar">
    <input
      class="chatbot-page__input"
      type="text"
      placeholder="Ask me about guardrails..."
      [(ngModel)]="query"
      (keydown)="onKeydown($event)"
      [disabled]="isSending"
      aria-label="Chat message input" />

    <button
      class="chatbot-page__btn chatbot-page__btn--new"
      (click)="newChat()"
      type="button">
      New Chat
    </button>

    <button
      class="chatbot-page__btn chatbot-page__btn--send"
      (click)="send()"
      [disabled]="!query.trim() || isSending"
      type="button">
      Send
    </button>
  </div>

</div>
